<div class="folder-buttons">
    <button mat-button (click)="changeFolder('profile')" [disabled]="folder === 'profile'">Profile</button>
    <button mat-button (click)="changeFolder('personal')" [disabled]="folder === 'personal'">Personal</button>
    <button mat-button (click)="changeFolder('processes')" [disabled]="folder === 'processes'">Processes</button>
  </div>
  
  <div class="file-list-container">
    <mat-list>
      <mat-list-item *ngFor="let file of files">
        <mat-icon>insert_drive_file</mat-icon>
        <span>{{ file.name }}</span>
        <button mat-button (click)="downloadFile(file.name)">Download</button>
        <button mat-button color="warn" (click)="deleteFile(file.name)">Delete</button>
      </mat-list-item>
    </mat-list>
    <a href="#" (click)="downloadFile('Pasaporte.pdf'); $event.preventDefault()">Download Document</a>
  
  </div>
  